import {
  futuraPTProBook,
  futuraPTProDemi,
  futuraPTProLight,
  futuraPTProMedium,
  apercuMonoRegularPro,
  acuminproRegularWebfont,
  acuminproLightWebfont,
  acuminproMediumWebfont,
  acuminproBoldWebfont,
  acuminproSemiboldWebfont
} from "./fonts";

export const fontVariants = {
  apercu: {
    fontFamily: apercuMonoRegularPro.style.fontFamily,
    fontFeatureSettings: "'liga' 0"
  },
  light0: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 0,
    lineHeight: 0,
    letterSpacing: "0.04em"
  },
  light1: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 1,
    lineHeight: 1,
    letterSpacing: "0.04em"
  },
  light2: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 3,
    lineHeight: 3,
    letterSpacing: "0.04em"
  },
  light3: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 5,
    lineHeight: 5,
    letterSpacing: "0.04em"
  },
  light4: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 8,
    lineHeight: 8,
    letterSpacing: "0.04em"
  },
  light5: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 13,
    lineHeight: 13,
    letterSpacing: "0.04em"
  },
  light6: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 17,
    lineHeight: 17,
    letterSpacing: "0.04em"
  },
  light7: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: 21,
    lineHeight: 21,
    letterSpacing: "0.04em"
  },
  lightM3: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: -3,
    lineHeight: -3,
    letterSpacing: "0.04em"
  },
  lightM2: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: -2,
    lineHeight: -2,
    letterSpacing: "0.04em"
  },
  lightM1: {
    fontFamily: futuraPTProLight.style.fontFamily,
    fontWeight: "light",
    fontSize: -1,
    lineHeight: -1,
    letterSpacing: "0.04em"
  },
  book0: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 0,
    lineHeight: 0,
    letterSpacing: "0.04em"
  },
  book1: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 1,
    lineHeight: 1,
    letterSpacing: "0.04em"
  },
  book2: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 3,
    lineHeight: 3,
    letterSpacing: "0.04em"
  },
  bookN2: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 2,
    lineHeight: 2,
    letterSpacing: "0.04em"
  },
  apercuN4: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 4,
    lineHeight: 4,
    letterSpacing: "0.04em"
  },
  book3: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 5,
    lineHeight: 5,
    letterSpacing: "0.04em"
  },
  book4: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 8,
    lineHeight: 8,
    letterSpacing: "0.04em"
  },
  book5: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 13,
    lineHeight: 13,
    letterSpacing: "0.04em"
  },
  book6: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 17,
    lineHeight: 17,
    letterSpacing: "0.04em"
  },
  book7: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 21,
    lineHeight: 21,
    letterSpacing: "0.04em"
  },
  bookM3: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: -3,
    lineHeight: -3,
    letterSpacing: "0.04em"
  },
  bookM2: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: -2,
    lineHeight: -2,
    letterSpacing: "0.04em"
  },
  bookM1: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: -1,
    lineHeight: -1,
    letterSpacing: "0.04em"
  },
  bookO1: {
    fontFamily: futuraPTProBook.style.fontFamily,
    fontWeight: "normal",
    fontSize: 6,
    lineHeight: 5,
    textTransform: "uppercase",
    letterSpacing: "6px"
  },
  medium0: {
    fontFamily: futuraPTProMedium.style.fontFamily,
    fontWeight: "normal",
    fontSize: 0,
    lineHeight: 0,
    letterSpacing: "0.04em"
  },
  demi0: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 0,
    lineHeight: 0,
    letterSpacing: "0.04em"
  },
  demi1: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 1,
    lineHeight: 1,
    letterSpacing: "0.04em"
  },
  demi2: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 3,
    lineHeight: 3,
    letterSpacing: "0.04em"
  },
  demiB2: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "boldish",
    fontSize: 2,
    lineHeight: 2,
    letterSpacing: "0.04em"
  },
  demi3: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 5,
    lineHeight: 5,
    letterSpacing: "0.04em"
  },
  demi4: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 8,
    lineHeight: 8,
    letterSpacing: "0.04em"
  },
  demi5: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 13,
    lineHeight: 13
  },
  demi6: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 17,
    lineHeight: 17
  },
  demi7: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 21,
    lineHeight: 21,
    letterSpacing: "0.04em"
  },
  demiM5: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -5,
    lineHeight: -5,
    letterSpacing: "0.04em"
  },
  demiM3: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -3,
    lineHeight: -3,
    letterSpacing: "0.04em"
  },
  demiM2: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -2,
    lineHeight: -2,
    letterSpacing: "0.04em"
  },
  demiM1: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -1,
    lineHeight: -1,
    letterSpacing: "0.04em"
  },
  caps0: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 0,
    lineHeight: 0,
    textTransform: "uppercase",
    letterSpacing: "0.04em"
  },
  caps1: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 1,
    lineHeight: 1,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps2: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 3,
    lineHeight: 3,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps3: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 5,
    lineHeight: 5,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps4: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 8,
    lineHeight: 8,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps5: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 13,
    lineHeight: 13,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps6: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 17,
    lineHeight: 17,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  caps7: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: 21,
    lineHeight: 21,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  capsM3: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -3,
    lineHeight: -3,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  capsM2: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -2,
    lineHeight: -2,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  capsM1: {
    fontFamily: futuraPTProDemi.style.fontFamily,
    fontWeight: "normal",
    fontSize: -1,
    lineHeight: -1,
    textTransform: "uppercase",
    letterSpacing: "0.16em"
  },
  acuminLight: {
    fontFamily: acuminproLightWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal"
  },
  acuminRegular: {
    fontFamily: acuminproRegularWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "24px"
  },
  acuminRegularM1: {
    fontFamily: acuminproRegularWebfont.style.fontFamily,
    fontWeight: 400,
    fontSize: -1,
    lineHeight: "18px",
    letterSpacing: "0.01rem"
  },
  acuminMedium: {
    fontFamily: acuminproMediumWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal"
  },
  acuminSemiBold: {
    fontFamily: acuminproSemiboldWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal"
  },
  acuminBold: {
    fontFamily: acuminproBoldWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal"
  },
  acuminCapsM1: {
    fontFamily: acuminproMediumWebfont.style.fontFamily,
    fontSize: "20px",
    lineHeight: "28px",
    textTransform: "uppercase"
  },
  acuminLight0: {
    fontFamily: acuminproLightWebfont.style.fontFamily,
    fontWeight: "normal",
    fontStyle: "normal",
    letterSpacing: "0.04em"
  }
};
